

































import { computed, defineComponent, ref } from '@vue/composition-api';
import soilApiService from '@/services/soilApiService';
import { useGroups } from '@/store/modules/group';
import { handleize } from '@/store/modules/group/utils';
import { hasMinimumLength, isNotEmpty } from '@/utils/rules';

export default defineComponent({
	components: {},
	props: {
		parentGroupId: { type: String, required: false },
	},
	emits: ['submitSuccess', 'cancel'],
	setup(props, { root, emit }) {
		const isFormValid = ref<boolean>(false);
		const form = ref();
		const name = ref<string>('');
		const createError = ref();
		const isLoading = ref(false);
		const { groups, isLoaded } = useGroups(root.$store);
		const error = computed<string>(() =>
			createError.value ? 'An error occurred while attempting to create the group. Please try again.' : ''
		);

		const siblingNames = computed<string[]>(() =>
			(props.parentGroupId
				? groups.value.find(({ id }) => id === props.parentGroupId)?.children || []
				: groups.value.filter(({ level }) => level === 1)
			).map(({ name }) => handleize(name))
		);

		const doesNotMatchSiblingName = (name: string) =>
			siblingNames.value.indexOf(handleize(name)) === -1 ||
			'A group with this name already exists, please choose another name';

		const handleCancel = () => {
			createError.value = null;
			form.value.reset();
			emit('cancel');
		};

		const handleSubmit = async () => {
			if (!isFormValid.value) {
				return;
			}
			try {
				isLoading.value = true;
				createError.value = null;

				const group = await soilApiService.createGroup({
					parentGroupId: props.parentGroupId ?? '',
					name: name.value,
				});

				form.value.reset();
				emit('submitSuccess', group.data);
			} catch (err) {
				createError.value = err;
			} finally {
				isLoading.value = false;
			}
		};

		return {
			isFormValid,
			name,
			error,
			isLoading,
			isLoaded,
			handleSubmit,
			handleCancel,
			hasMinimumLength,
			isNotEmpty,
			doesNotMatchSiblingName,
			siblingNames,
			form,
		};
	},
});
